<template>
  <div id="footer">
  
      <div class="footer-about">
          <!-- <p><span>联系我们</span>|<span>网站地图</span></p> -->
          <p>Copyright 2019 www.gcphr.cn All Rights Reserved. 版权所有 | 京ICP备18043715号-2<br>研发单位：北京原素生物医药科技有限公司</p>
      </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  }
};
</script>
<style scoped>

 .footer-about{
     background: #333;
     /* height: 80px; */
     color: #fff;
     text-align: center;
 }
 /* .footer-about p:first-child{
    height: 74px;
    line-height: 74px;
    border-bottom: solid 1px rgba(255,255,255,0.3)
 }
 .footer-about p:first-child span{
     padding:0 35px;
     font-size: 14px;
 } */
 .footer-about p:last-child{
     height: 53px;
     padding-top: 10px;
     box-sizing: border-box;
     font-size: 12px;
 }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue